import { put, call } from "redux-saga/effects";

import { GET_RCREPORTS_COMPLETED,GET_RCREPORTS_FAILED,GET_REFRESH_FAILED,GET_REFRESH_COMPLETED} from "../actions/Rcreports";

import { RCreportAPI } from "../../utils/api/RcreportingAPI";

export function* getRCREPORTS(request: any) {
    try {
      const result = yield call(RCreportAPI.getmeterserialdetail,request.input);
      
          yield put({
              type: GET_RCREPORTS_COMPLETED,
              payload: result.data,
              input: request.input
          });        
          
      } catch (e) {        
          yield put({ type: GET_RCREPORTS_FAILED, payload: e.message });
      }
  }
  export function* getREFRESH(request: any) {
    try {
      const result = yield call(RCreportAPI.getrefresh,request.input);
    
  
          yield put({
              type: GET_REFRESH_COMPLETED,
              payload: result.data,
              input: request.input
          });        
          
      } catch (e) {        
          yield put({ type: GET_REFRESH_FAILED, payload: e.message });
      }
  }